/* Step 11d · A2 (owner 01-Nov-2026) — the one way a polling screen prints a failed background job's error.

   A failed job row carries its English sentence in `error` and, when the server has one, the Arabic sentence in `error_ar`
   (the neutral AI kinds of Step 11c · item 1, the engagement cap, the unrecorded-liabilities uploads, the GL commit whose
   staged rows expired …) plus its code in `error_code`. Before this, most polling screens printed `job.error`, so an Arabic
   screen showed the English sentence. Now, on an Arabic screen: `error_ar`, else the screen's own translation of the code
   (errors.<CODE>), else the English text; on an English screen: the English text. A provider's raw text from an older row is
   still shown as the neutral kind (lib/aiErrorText). `fallback` when the job carries no error at all. */
import { aiErrorText } from "@/lib/aiErrorText";

export function jobErrorText(job, lang, t, fallback = "") {
  if (!job) return fallback;
  if (lang === "ar") {
    if (job.error_ar) return String(job.error_ar);
    if (job.error_code && typeof t === "function") {
      const key = `errors.${job.error_code}`;
      const tr = t(key);
      if (tr && tr !== key) return tr;
    }
  }
  const en = String(job.error || "");
  if (!en) return fallback;
  return typeof t === "function" ? aiErrorText(t, en, { code: job.error_code }) : en;
}
